const PAST_BOARD_MEETINGS_SELECTOR =
  '[data-testid="section-past-board-meetings"]';

let outsideClickHandlerAttached = false;

function closeDropdown(section) {
  const toggle = section.querySelector("#year-toggle");
  const container = section.querySelector("#year-options-container");
  const downIcon = section.querySelector("#down-year-icon");

  if (!container) return;

  container.classList.add("hidden");
  downIcon?.classList.remove("rotated");
  toggle?.setAttribute("aria-expanded", "false");
}

function attachOutsideClickHandler() {
  if (outsideClickHandlerAttached) return;
  outsideClickHandlerAttached = true;

  document.addEventListener("click", (e) => {
    document
      .querySelectorAll(PAST_BOARD_MEETINGS_SELECTOR)
      .forEach((section) => {
        const toggle = section.querySelector("#year-toggle");
        const container = section.querySelector("#year-options-container");

        if (
          toggle &&
          container &&
          !toggle.contains(e.target) &&
          !container.contains(e.target)
        ) {
          closeDropdown(section);
        }
      });
  });
}

function initPastBoardMeetingsSection(section) {
  if (section.dataset.pastBoardMeetingsInitialized === "true") return;

  const toggle = section.querySelector("#year-toggle");
  const container = section.querySelector("#year-options-container");
  const selectedText = section.querySelector("#selected-year-options");
  const checkboxes = container?.querySelectorAll(".year-checkbox") || [];
  const clearIcon = section.querySelector("#clear-year-icon");
  const downIcon = section.querySelector("#down-year-icon");
  const cards = section.querySelectorAll(
    "#meetings-container > a, #meetings-container > div",
  );

  if (!toggle || !container || !cards.length) return;

  section.dataset.pastBoardMeetingsInitialized = "true";

  function filterCards() {
    const selectedYears = Array.from(checkboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);

    if (selectedText) {
      selectedText.textContent = selectedYears.length
        ? selectedYears.join(", ")
        : "Filter by Year";
    }

    clearIcon?.classList.toggle("hidden", selectedYears.length === 0);

    cards.forEach((card) => {
      const cardYear = card.getAttribute("data-year");
      if (selectedYears.length === 0 || selectedYears.includes(cardYear)) {
        card.style.display = "";
        card.classList.remove("hidden");
      } else {
        card.style.display = "none";
        card.classList.add("hidden");
      }
    });

    const visibleCards = Array.from(cards).filter(
      (card) =>
        card.style.display !== "none" && !card.classList.contains("hidden"),
    );
    const containerEl = section.querySelector("#meetings-container");
    const noResultsMsg = section.querySelector("#no-results-message");

    if (visibleCards.length === 0) {
      if (!noResultsMsg && containerEl) {
        const message = document.createElement("div");
        message.id = "no-results-message";
        message.className =
          "text-center text-brand-black-secondary font-Inter py-10 col-span-full";
        message.textContent =
          "No meeting minutes found for the selected year(s).";
        containerEl.appendChild(message);
      }
    } else {
      noResultsMsg?.remove();
    }
  }

  toggle.addEventListener("click", (e) => {
    e.stopPropagation();

    container.classList.toggle("hidden");
    downIcon?.classList.toggle(
      "rotated",
      !container.classList.contains("hidden"),
    );
    toggle.setAttribute(
      "aria-expanded",
      !container.classList.contains("hidden"),
    );
  });

  container.addEventListener("click", (e) => {
    e.stopPropagation();
  });

  checkboxes.forEach((cb) => {
    cb.addEventListener("change", filterCards);
  });

  clearIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    checkboxes.forEach((cb) => (cb.checked = false));
    filterCards();
  });
}

export function initPastBoardMeetings(root = document) {
  const sections = root.querySelectorAll(PAST_BOARD_MEETINGS_SELECTOR);
  if (!sections.length) return;

  attachOutsideClickHandler();
  sections.forEach(initPastBoardMeetingsSection);
}

document.addEventListener("DOMContentLoaded", () => {
  initPastBoardMeetings();
});

document.addEventListener("ajax:loaded", () => {
  initPastBoardMeetings();
});
